module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/nagoya_concept_02-58dff2a44b2fa6d00a8c4fcc4892286b.jpg";